export const en = {
  signIn: 'Sign In',
  signOut: 'Sign Out',
  register: 'Register',
  or: 'or',
  noHaveAccount: "Don't have an account?",
  nik: 'ID CARD(KTP)',
  fullname: 'Full Name',
  position: 'Position',
  gender: 'Select Gender',
  phoneNumber: 'Number Phone',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  alreadyAccount: 'Already have account?',
  greeting: 'Have a nice day',
  hello: 'Hi',
  moduleAvailable: 'Available Module',
  moduleTotal: 'Total Module',
  taskTotal: 'Total Task',
  historyOfModules: 'Module History',
  noHaveHistory: 'No have history',
  Home: 'Home',
  User: 'Me',
  dateOfBirth: 'Date of Birth',
  selectLang: 'Select Language',
  buttonLang: {
    confirm: 'Apply',
    cancel: 'Close',
  },
  registerUser: {
    success: 'Successfully registered',
    desc: 'Waiting for the admin to verify or contact the admin to verify the account',
  },
}
